import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { CheckCircleTwoTone } from "@ant-design/icons";
const ConsignmentRequirementsTable = ({ consignment }) => {
    const icon = _jsx(CheckCircleTwoTone, { twoToneColor: "#52c41a" });
    // console.log(
    //     "consignment.pickUpPhotoRequired", consignment.pickUpPhotoRequired,
    //     "consignment.completionPhotoRequired", consignment.completionPhotoRequired,
    //     "consignment.completionSignatureRequired", consignment.completionSignatureRequired
    // );
    if (!consignment) {
        return null;
    }
    return (_jsx("table", { style: { marginBottom: '10px' }, children: _jsxs("tbody", { children: [consignment.pickUpPhotoRequired &&
                    _jsxs("tr", { children: [_jsx("td", { children: icon }), _jsx("td", { children: "Pickup Photo" })] }), consignment.completionPhotoRequired &&
                    _jsxs("tr", { children: [_jsx("td", { children: icon }), _jsx("td", { children: "Delivery Photo" })] }), consignment.completionSignatureRequired &&
                    _jsxs("tr", { children: [_jsx("td", { children: icon }), _jsx("td", { children: "Delivery Signature" })] }), (consignment.specialRequirements || []).map((sr, index) => {
                    return (_jsxs("tr", { children: [_jsx("td", { children: icon }), _jsx("td", { children: sr.title })] }, sr.id));
                })] }) }));
};
export default ConsignmentRequirementsTable;
